
import * as api from 'api/marketplace/revenue/referral';
import {
  referralDetailActions,
  selectReferralDetailLoading,
  selectReferralDetailQueryString,
} from 'features/revenue/referral/referralDetailSlice';
import { toastAction } from 'features/toast/toastSlice';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const { loadData, loadDataSuccess, loadDataFailure } = referralDetailActions;

function* loadDataSaga() {
  const loading: boolean = yield select(selectReferralDetailLoading);
  if (!loading) return;
  const query: string = yield select(selectReferralDetailQueryString);
  
  const { data, error } = yield call(api.getReferralRevenueDetails, query);
  if (error) {
    yield put(toastAction.errorResponse(error));
    yield put(loadDataFailure());
    return;
  }
  yield put(loadDataSuccess(data));
}

export default function* referralDetailSaga() {
  yield all([takeLatest(loadData, loadDataSaga)]);
}
